import { useId } from "react";
import { useItems } from "../api";

/**
 * Where a lot of hops was grown, typed or picked from the regions this brewery's hops already name.
 * Anything typed is kept: a state ("Michigan") as well as a country.
 */
export function RegionInput({
  value,
  onChange,
  placeholder,
  label,
  disabled,
  id,
  "aria-describedby": describedBy,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** For a field with no label beside it, as in a table. */
  label?: string;
  disabled?: boolean;
  /** From `Field`, which labels the control by id: passed to the input, not the fragment. */
  id?: string;
  "aria-describedby"?: string;
}) {
  const listId = useId();
  const { data: items = [] } = useItems();
  const regions = [
    ...new Set(
      items.filter((i) => i.category === "hop" && i.origin).map((i) => i.origin as string),
    ),
  ].sort();
  return (
    <>
      <input
        className="input"
        id={id}
        list={listId}
        value={value}
        placeholder={placeholder}
        aria-label={label}
        aria-describedby={describedBy}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      />
      <datalist id={listId}>
        {regions.map((r) => (
          <option key={r} value={r} />
        ))}
      </datalist>
    </>
  );
}
